<script>
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";
import CommitAction from "%/dynamic-component-editor/options/commit-action";
import MediaTypeField from "%/dynamic-component-editor/options/media-type-field";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";

export default {
  name: "FileUploadContainer",
  extends: Container,
  mixins: [DynamicElementWithContext],
  elementPanelSettings: {
    alias: "File Upload Container",
    displayName: "File Upload",
    displayIcon: "mdi:file-upload-outline",
    tags: ["container", "file", "upload", "attachment", "dropzone"],
  },
  options: [
    ContextBindings,
    CommitAction,
    MediaTypeField,
  ],
  optionBundles: [
    PositioningOptions,
    new LayoutPositionOptions({
      "default.static-layout-direction": "horizontal",
    }),
    SpacingOptions,
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    BackgroundOptions,
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
  ],
  computed: {
    canvasHint() {
      return this.isEmpty ? "Drop the upload icon, labels and button in here" : "";
    },
  },
};
</script>
